$('.modal-button').on('click', function(){
  $('.modal').addClass('is-active');
  $('html').addClass('open');
  var video = $('.modal video').get(0);
  if (video) {
    video.currentTime = 0;
    video.play();
  }
});

$('.modal_dialog-close').on('click', function () {
  // Travel up the DOM tree to find ONLY the parent modal of this close button
  var $modal = $(this).closest('.modal');

  $modal.removeClass('is-active');
  $('html').removeClass('open');

  // Pause ONLY the video inside this closing modal
  var video_play = $modal.find('video').get(0);
  if (video_play) {
    video_play.pause();
  }
});

$('.video-container').on('click', function () {
  // Get the ID of the clicked video trigger
  var playId = $(this).data('play-id');

  // Find and isolate the exact matching modal using the ID
  var $modal = $('.video-modal[data-modal-id="' + playId + '"]');

  $modal.addClass('is-active');
  $('html').addClass('open');

  // Target only the video nested inside this specific modal configuration
  var video_play = $modal.find('.video-modal__dialog video').get(0);
  if (video_play) {
    video_play.currentTime = 0;
    video_play.play();
  }
});

$('.video-modal__close').on('click', function () {
  // Read the targeted close ID attribute
  var close_id = $(this).data('modal-close');
  var $video_modal;

  // Fallback: If data-modal-close is missing, find the parent container automatically
  if (close_id) {
    $video_modal = $('.video-modal[data-modal-id="' + close_id + '"]');
  } else {
    $video_modal = $(this).closest('.video-modal');
  }

  // Close the isolated modal instance
  $video_modal.removeClass('is-active');
  $('html').removeClass('open');

  // Pause only the video belonging to this specific modal layout
  var video_play = $video_modal.find('video').get(0);
  if (video_play) {
    video_play.pause();
  }
});

$('.lead-member.with-video').on('click', function(){
  var playVideo = $(this).data('video');

  var $member_modal = $('.lead-member-video__modal[data-member-video="' + playVideo + '"]');

  $member_modal.addClass('active');
  $('html').addClass('open');

  var member_video_play = $member_modal.find('video').get(0);

  if(member_video_play){
    member_video_play.currentTime = 0;
    member_video_play.play();
  }
});

$('.lead-member-video__modal-close').on('click', function(){
  var video_close = $(this).data('member-close');
  var member_modal;

  if(video_close){
    member_modal = $('.lead-member-video__modal[data-member-video="' + video_close + '"]');
  } else{
    member_modal = $(this).closest('.lead-meber-video__modal');
  }

  member_modal.removeClass('active')
  $('html').removeClass('open');

  var play = member_modal.find('video').get(0);
  if(play){
    play.pause();
  }
});
